import React from "react";
import { CustomCard } from "../../CustomCard";
import { Box, Divider } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

const AgentCardSkeleton = ({}) => {
  const styles = useStyles();
  return (
    <CustomCard
      boxShadow="xs"
      borderRadius="xl"
      borderColor="secondary"
      classes={styles.containerCardAgent}
    >
      <Box className={styles.containerImgName}>
        <Skeleton
          className={styles.dot}
          variant="circle"
          width={54}
          height={54}
          animation="wave"
        />
        <Box className={styles.containerHeaderInfo}>
          <Skeleton variant="text" width={100} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Box>
      </Box>
      <Divider className={styles.divider} />
      <Box className={styles.containerCourses}>
        {[...Array(2)].map((_, index) => (
          <Box key={index} className={styles.containerCourse}>
            <Box className={styles.containerHeaderCourse}>
              <Skeleton variant="rect" width={100} height={15} />
              <Skeleton variant="rect" width={20} height={15} />
            </Box>
            <Skeleton variant="text" width={100} height={25} />
          </Box>
        ))}
      </Box>
    </CustomCard>
  );
};

export default AgentCardSkeleton;
